import React from 'react'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import zohranImg from '../images/ZohranHeadshot.png'

export default function ZohranEndorsment() {
    return (
        <Container
            sx={{
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                border: '2px solid #9e522a',
                borderRadius: '10px',
            }}
        >
            <Typography
                variant="h1"
                color="black"
                sx={{ fontWeight: 'bold', textDecoration: 'underline' }}
            >
                Zohran Mamdani
            </Typography>
            <Typography variant="h2" color="black" sx={{ fontWeight: 'bold' }}>
                New York City&apos;s Top Progressive Pick For Mayor
            </Typography>
            <Container maxWidth="md" sx={{ py: 4 }}>
                <Box
                    sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 3,
                        justifyContent: 'center',
                    }}
                >
                    <Box
                        component="img"
                        src={zohranImg}
                        alt="Zohran Mamdani"
                        sx={{
                            width: '100%',
                            maxWidth: '250px',
                            height: 'auto',
                            objectFit: 'contain',
                            flexShrink: 0,
                        }}
                    />

                    <Box
                        sx={{
                            flex: '1 1 300px',
                            minWidth: '280px',
                        }}
                    >
                        <Typography
                            variant="body1"
                            sx={{
                                mb: 2,
                                textAlign: 'left',
                                fontSize: '1.1rem',
                            }}
                        >
                            NYC Progressive Organizations Have Ranked Zohran
                            Mamdani as their #1 choice for mayor in the 2025
                            Democratic Primary for New York City Mayor on June
                            24. Zohran currently serves as a New York State
                            Assembly Member and has a strong background in
                            tenant organizing that has informed his boldly
                            progressive legislative record. His leadership on
                            housing justice, public safety, universal
                            healthcare, wealth redistribution, and Palestinian
                            solidarity aligns with the values we champion at{' '}
                            <span style={{ textDecoration: 'underline' }}>
                                thedownballot.org
                            </span>
                        </Typography>

                        <Typography
                            variant="body1"
                            sx={{
                                mb: 2,
                                textAlign: 'left',
                                fontWeight: 'bold',
                                fontSize: '1.1rem',
                                fontStyle: 'italic',
                            }}
                        >
                            In addition to ranking Zohran first, we very
                            strongly urge you to rank 4 other candidates to
                            prevent Andrew Cuomo from securing the Democratic
                            nomination ahead of the General Election in
                            November. Please consider ranking additional
                            candidates to build the strongest possible ticket.
                        </Typography>
                    </Box>
                </Box>
            </Container>
        </Container>
    )
}
